/**
 * Hides the desktop menu with optional animation.
 *
 * This function removes the animation-in class and adds the animation-out class (if specified)
 * to the menu element, then sets the menu's display style to 'none'.
 *
 * @param {HTMLElement} el - The element that triggers the hide action.
 * @param {HTMLElement} menu - The menu element to hide.
 * @param {Object} params - Configuration parameters (not used in this function).
 * @param {Object} itemParams - Item-specific parameters.
 * @param {Object} itemParams.desktop - Desktop-specific parameters.
 * @param {string} itemParams.desktop.animationIn - The class for the animation-in effect.
 * @param {string} itemParams.desktop.animationOut - The class for the animation-out effect (optional).
 * @returns {void}
 */
export default function desktopHide(el, menu, params, itemParams) {
  if (!menu) {
    return this;
  }

  const { animationIn, animationOut } = itemParams.desktop;

  menu.classList.remove(animationIn);

  if (animationOut) {
    menu.classList.add(animationOut);
  }

  menu.style.display = 'none';
}
